<template>
  <div class="flex flex-col">
    <div class="flex flex-row items-center gap-2">
      <div v-html="TAGS_ICON" class="text-primary-purple w-6 h-6"></div>
      <div class="flex flex-col">
        <div
          class="text-black font-inter text-base font-semibold normal-case leading-6"
        >
          Expert Tags
        </div>
      </div>
    </div>
    <div
      class="flex flex-col text-left mt-2 rounded-lg border border-gray-200 p-4"
    >
      <div class="flex flex-row items-center justify-between">
        <div class="flex flex-col">
          <span class="text-black text-md font-medium text-sm"
            >Expert Tags</span
          >
        </div>
        <div class="flex flex-col">
          <div class="flex flex-col">
            <div class="flex flex-col justify-center">
              <button
                class="flex items-center w-11 h-6 rounded-full transition-colors duration-300"
                :class="{
                  'bg-violet-600': showExpertTagsList,
                  'bg-gray-200': !showExpertTagsList,
                }"
                @click="togglePayoutSetting"
                aria-label="Toggle button"
              >
                <span
                  class="flex self-stretch my-auto w-4 h-4 bg-white rounded-full transition-transform duration-300 transform"
                  :class="{
                    'translate-x-6': showExpertTagsList,
                    'translate-x-1': !showExpertTagsList,
                  }"
                ></span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showExpertTagsList" class="flex flex-col mt-2">
        <ExpertTagsList v-model="listOfexpertTags" :showTitle="false" />
      </div>
      <div class="flex flex-col mt-4 items-end">
        <BaseButton
          type="button"
          @click="handleUpdateClick"
          class="px-4 py-2 text-xs max-w-max font-medium leading-none border border-gray-300 rounded-md text-white bg-primary-purple"
        >
          Save Changes
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref, watch } from "vue";
import { TAGS_ICON } from "@/assets/svg/shared/svg-constants";
import ExpertTagsList from "@/components/expert-program/program-details/ExpertTagsList.vue";
import BaseButton from "@/components/shared/BaseButton.vue";

export default defineComponent({
  name: "ExpertTags",
  components: {
    ExpertTagsList,
    BaseButton,
  },
  props: {
    initialExpertTags: {
      type: Array as PropType<string[]>,
      required: true,
    },
    initialShowExpertTagsList: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["updateExpertTags", "saveExpertTags"],
  setup(props, { emit }) {
    const showExpertTagsList = ref(props.initialShowExpertTagsList);
    const listOfexpertTags = ref(props.initialExpertTags);

    const togglePayoutSetting = () => {
      showExpertTagsList.value = !showExpertTagsList.value;
      if (!showExpertTagsList.value) {
        listOfexpertTags.value = [];
      }
    };

    const handleUpdateClick = () => {
      emit("saveExpertTags");
    };

    watch(
      listOfexpertTags,
      (newVal) => {
        emit("updateExpertTags", newVal);
      },
      { deep: true }
    );

    watch(
      () => props.initialShowExpertTagsList,
      (newVal) => {
        showExpertTagsList.value = newVal;
      }
    );

    watch(
      () => props.initialExpertTags,
      (newVal) => {
        listOfexpertTags.value = newVal;
      }
    );

    return {
      TAGS_ICON,
      showExpertTagsList,
      togglePayoutSetting,
      listOfexpertTags,
      handleUpdateClick,
    };
  },
});
</script>
